import { ArrowLeft, CalendarIcon, ChevronLeft, ChevronRight, Home } from "lucide-react";
import { Layout } from "./Layout";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "./ui/breadcrumb";
import { AppContext } from '../src/App';
import { useContext, useEffect, useMemo, useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader } from "./ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { apiClient } from "@/Utils/apiClient";
import { useAuth } from "./AuthContext";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Badge } from "./ui/badge";
import { PaginationCustom } from "./ui/pagination-custom";
import { Checkbox } from "./ui/checkbox";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { toast } from "sonner";
import { format } from "date-fns";
import { Calendar } from "../components/ui/calendar";
import { Popover,PopoverContent,PopoverTrigger,PopoverAnchor } from "./ui/popover";
import { buildQuery, flattenFilters } from "@/Utils/helpers";
interface Chart {
  id: string;
  name: string;
  clientId: string;
}
interface ChartData {
  charts: Chart[]|[];
  pagination: {
    totalCount: number;
    totalPages: number;
  };
}

export function KanTimeUpdate() {
  const { setCurrentView ,selectedHarvestRunData,setSelectedHarvestRunData} = useContext(AppContext);
  const [selectedCharts, setSelectedCharts] = useState<string[]>([]);
  const [chartsData, setChartsData] = useState<ChartData>();
  const [currentPage, setCurrentPage] = useState(1);
  const [isSelectedAll, setIsSelectedAll] = useState(false)
  const [updateKT, setUpdateKT] = useState(false)
  const currentCharts = useMemo(() => chartsData?.charts ?? [], [chartsData?.charts]);
  const [dateRange, setDateRange] = useState({
  from: new Date(),
  to: new Date(),
});

const [tempRange, setTempRange] = useState<{ from: Date | null; to: Date | null }>(dateRange);
  const [showDatePicker,setShowDatePicker]=useState(false)
  const { token } = useAuth();

  const itemsPerPage = 15;
  const fetchData = async () => {
    try {
      // const flat=flattenFilters(dateRange);
      const queryParams={
        from:dateRange.from.toLocaleDateString(),
        to:dateRange.to.toLocaleDateString(),
        page:currentPage,
        limit:itemsPerPage,
        runId:selectedHarvestRunData?selectedHarvestRunData:null
      }
      const query=buildQuery(queryParams,{
        fromDate:"from",
        toDate:"to",
        runId:"runId",
        page:"page",
        limit:"limit"
      })
      const response = await apiClient(`audits/charts/auditor/review?${query}`, {
        method: 'GET',
        token
      })
      const result = await response.json()
      if(!result.success){
        throw new Error("Failed to get Approved charts")
      }
      setChartsData(result?.data);

    }
    catch (error:any) {
     if(error.status<500){
      toast.error(error.message)

     }
    }

  }
  // Fetch data when page changes
  useEffect(() => {
    fetchData();
  }, [currentPage,dateRange.from,dateRange.to]);

  // Update “isSelectedAll” whenever selection or page data changes
  useEffect(() => {
    if (currentCharts.length === 0) return;
    const allSelected = currentCharts.every(chart => selectedCharts.includes(chart.id));
    setIsSelectedAll(allSelected);
  }, [selectedCharts, currentCharts]);

  // Pagination

  const totalItems = chartsData?.pagination?.totalCount || 0;
  const totalPages = chartsData?.pagination?.totalPages || Math.ceil((chartsData?.charts?.length) || 0 / itemsPerPage);
  const onPageChange = (page: number) => {
    setCurrentPage(page);
  };
  //   convert Words to camelCase
  const toCamelCase = (str: string) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());
  };

  const handleChartToggle = (id: string) => {
    setSelectedCharts(prev =>
      prev.includes(id) ? prev.filter(cid => cid !== id) : [...prev, id]
    );
  };

  // toggle all for this page
  const handleSelectAll = (pageData: Chart[]) => {
    const pageIds = pageData?.map(c => c.id);
    const allSelected = pageIds?.every(id => selectedCharts.includes(id));

    if (allSelected) {
      // unselect all from this page
      setSelectedCharts(prev => prev.filter(id => !pageIds.includes(id)));
      setIsSelectedAll(false)
    } else {
      // add all ids of this page
      setSelectedCharts(prev => [
        ...prev,
        ...pageIds.filter(id => !prev.includes(id)),
      ]);
      setIsSelectedAll(true)
    }
  };

  // helpers for header checkbox
  const isHeaderChecked = (pageData: Chart[]) =>
    pageData?.length > 0 &&
    pageData?.every(c => selectedCharts.includes(c.id));

  const handleBackToHarvest = () => {
    setSelectedHarvestRunData(undefined)
    setCurrentView('chat-harvest');

  }

  //update KanTime
  const handleUpdateKantTime = async () => {
    try {

//       const body={
//     "UIUpdate":true
// }
//     await apiClient('audits/charts/update/ui/kt',{
//       method:'POST',
//       token,
//       body
//     })
      const ids = getSelectedIds(chartsData?.charts??[])
      const bodyCharts = {
        auditIds: ids
      }
      const response = await apiClient('audits/auditor/selected/charts', {
        method: 'PUT',
        token,
        body:bodyCharts
      })
      const result = await response.json()
      if (!result?.success) {
        throw new Error("Failed to update charts")
        // await fetchData();

      }
      toast.success(result?.message)

    } catch (error: any) {
      console.log(error)
      if (error.status < 500) {
        toast.error(error.message);

      }
      else {
        toast.error("Something went wrong please try again");

      }


    }
    finally {
      setUpdateKT(false)
      fetchData();
      setSelectedCharts([])
      // setCurrentView('chat-harvest')
    }
  }
  // get all selected ids 
  const getSelectedIds = (allCharts: Chart[]): string[] => {
  return allCharts.filter(chart => selectedCharts.includes(chart.id)).map(chart => chart.id);
};

  //  for manual selected to enable select all option
  // const isHeaderChecked = () => {
  //   if (globalSelectAll) return deselectedCharts.length === 0;
  //   if (!chartsData?.charts?.length) return false;
  //   return chartsData.charts.every(chart => selectedCharts.includes(chart.id));
  // };

  // const isHeaderIndeterminate = () => {
  //   if (globalSelectAll) return deselectedCharts.length > 0;
  //   if (!chartsData?.charts?.length) return false;
  //   const someSelected = chartsData.charts.some(chart => selectedCharts.includes(chart.id));
  //   const allSelected = chartsData.charts.every(chart => selectedCharts.includes(chart.id));
  //   return someSelected && !allSelected;
  // };
  const currentPageSelectedCount = chartsData?.charts.filter(chart =>
    selectedCharts?.includes(chart.id)
  ).length;
  return (
    <Layout>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-white">
        <div className="p-8">
          {/* Breadcrumb Navigation */}
          <div className="mb-6">
            <Breadcrumb>
              <BreadcrumbList>
                {/* <BreadcrumbItem>
                  <BreadcrumbLink href="#" onClick={handleBackToDashboard} className="flex items-center gap-2">
                    <Home className="w-3 h-3" />
                    Dashboard
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator /> */}
                <BreadcrumbItem>
                  <BreadcrumbLink href="#" onClick={handleBackToHarvest}>
                    Chart Review
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage>Update KanTime</BreadcrumbPage>
                  {/* <BreadcrumbPage>Chart Details</BreadcrumbPage> */}
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>
          {/* Header with Back Button */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-4">
              <Button
                variant="outline"
                onClick={handleBackToHarvest}
                className="flex items-center gap-2"
              >
                <ArrowLeft className="w-4 h-4" />
                Back to Chart Review
              </Button>
              <div>
                Update Charts to KanTime
              </div>
            </div>
            {/* <Badge variant="outline" className={runData.status === 'Completed' ? 'bg-green-50 text-green-700 border-green-200' : 'bg-gray-50'}>
              {runData.status}
            </Badge> */}
          </div>
          <Card className="bg-white/90 backdrop-blur-sm border-gray-200 shadow-lg">
            <CardHeader>
              <div className="mx-2 text-md">Agreed Charts Summary</div>
              <div className="flex justify-center justify-between mx-2">
                <div className="flex justify-center items-center gap-2">
                  <Checkbox
                      checked={isSelectedAll ?? false}
                      onCheckedChange={() => handleSelectAll(chartsData?.charts??[])}
                      className="h-4 w-4 accent-black bg-white border border-gray-400 rounded-sm cursor-pointer"
                    />
                  <label className="text-[15px] text-gray-500 ">
                     Select All
                  </label>
                    
                   
                </div>
                <div className="flex items-center gap-2">
                  {/* <div className="bg-gray-100 rounded"onClick={()=>setShowDatePicker(true)}>
                    <div className="flex items-center h-10 px-2" >
                      <CalendarIcon className="w-4 h-4" />
                       <span className="text-xs text-gray-600 font-medium mx-1">
                                  {format(dateRange.from, "MMM dd")} — {format(dateRange.to, "MMM dd")}
                                </span>
                    </div>

                  </div> */}
                   <Popover open={showDatePicker} onOpenChange={setShowDatePicker}>
    <PopoverTrigger asChild>
  <button className="bg-gray-100 rounded flex items-center h-10 px-2 gap-1">
    <CalendarIcon className="w-4 h-4" />
    <span className="text-xs text-gray-600 font-medium">
      {dateRange.from && dateRange.to
        ? `${format(dateRange.from, "MMM dd")} — ${format(dateRange.to, "MMM dd")}`
        : "Select Date Range"}
    </span>
  </button>
</PopoverTrigger>


    <PopoverContent
      className="w-auto p-0 mx-4"
      side="bottom"
      align="start"
      sideOffset={8}
    >
      <div className="p-4">
        <div className="text-xs font-medium mb-2">Select Date Range</div>
        <div className="grid grid-cols-2 gap-1">
          <div>
            <div className="text-xs text-muted-foreground">From</div>
            <Calendar
             className="scale-90"   // shrink everything by 90%
  classNames={{
    day: "size-6 p-0 text-xs",      // smaller day cells
    head_cell: "w-6 text-[10px]",   // smaller header
    caption_label: "text-xs",       // smaller month label
  }}
              mode="single"
              selected={tempRange.from ?? undefined}
              onSelect={(date) => date && setTempRange((prev) => ({ ...prev, from: date }))}
              initialFocus
              disabled={{ after: new Date() }} 
            />
          </div>
          <div>
            <div className="text-xs text-muted-foreground">To</div>
            <Calendar
                className="scale-90"   // shrink everything by 90%
  classNames={{
    day: "size-6 p-0 text-xs",      // smaller day cells
    head_cell: "w-6 text-[10px]",   // smaller header
    caption_label: "text-xs",       // smaller month label
  }}
              mode="single"
              selected={tempRange.to ?? undefined}
              onSelect={(date) => date && setTempRange((prev) => ({ ...prev, to: date }))}
              disabled={{ after: new Date() }} 
            />
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-4">
          <Button variant="outline" size="sm" onClick={() => setShowDatePicker(false)}>
            Cancel
          </Button>
          <Button
            size="sm"
            onClick={() => {
              setDateRange(tempRange);
              setShowDatePicker(false);
            }}
          >
            Apply
          </Button>
        </div>
      </div>
    </PopoverContent>
  </Popover>
                  <Button onClick={() => setUpdateKT(true)} className={`px-4 py-2 rounded 
  ${selectedCharts.length > 0 
    ? " text-white cursor-pointer opacity-100" 
    : " text-white opacity-50 cursor-not-allowed pointer-events-none"}`}>
                    Update KanTime
                  </Button>

                </div>

              </div>
            </CardHeader>
            <CardContent>
              {isSelectedAll && (
                <div className="text-center bg-gray-100 text-sm font-inter py-2 rounded mb-2 font-medium mx-2">
                  {`All ${currentPageSelectedCount} charts are selected in this page`}
                </div>
              )}

              <div className="overflow-x-auto mx-2">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-gray-50 hover:bg-gray-50">

                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Chart Id</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Client id</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">CLIENT NAME</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Visit Date</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195] ">Chart Type</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]  text-wrap">AI Decision</TableHead>
                      {/* <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]  text-wrap">Auditor Review Status</TableHead> */}
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">supervisor Name</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195] text-wrap">auditor Comment</TableHead>
                      {/* <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Check In Time</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Check Out Time</TableHead>
                      <TableHead className="font-inter font-semibold text-[14px] leading-[100%] tracking-[-0.5%] uppercase text-[#758195]">Hours Spend</TableHead> */}
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {/* {paginatedData.map(item=>{
                            return(
                                <TableRow>
                                    <TableCell>
                                        <div>

                                        </div>
                                    </TableCell>
                                     <TableCell>
                                        <div>
                                            
                                        </div>
                                    </TableCell>
                                     <TableCell>
                                        <div>
                                            
                                        </div>
                                    </TableCell>


                                </TableRow>
                            )
                        })} */}
                        {chartsData?.charts?.length === 0 && (
                                              <TableRow>
                                                <TableCell colSpan={8} className="text-center py-12">
                                                  No Data Found
                                                </TableCell>
                                              </TableRow>
                                            )}

                    {chartsData?.charts?.map((goal: any, index) => {
                      const outcome = goal?.outcome?.toLowerCase();
                      return (
                        <TableRow
                          key={goal?.id}
                          className="hover:bg-blue-50/50 transition-colors"
                          title="Click to view goal details"
                        >
                          <TableCell className="m-4 font-medium text-gray-600">
                            <label key={goal.id} className="flex items-center gap-2">
                              <Checkbox
                                checked={selectedCharts.includes(goal.id)}
                                onCheckedChange={() => handleChartToggle(goal.id)}
                                className="h-4 w-4 accent-black bg-white border border-gray-400 rounded-sm cursor-pointer"
                              />
                              {goal.chartId}
                            </label>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600">{goal?.clientId}
                              </span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col text-wrap w-32">
                              <span className="font-medium text-gray-600">{goal?.clientName}</span>
                              <span className="text-xs text-gray-500">
                              </span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600">{goal?.visitDate}
                              </span>
                            </div>
                          </TableCell>

                          <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600">{goal?.section}</span>
                            </div>
                          </TableCell>

                          <TableCell className="max-w-[120px] align-top">
                            <div className="flex flex-col w-full">
                              <span className="font-medium text-gray-500 break-words whitespace-normal w-full">
                                {goal?.overallAuditDecision}
                              </span>

                              {/* <span className="text-xs text-gray-600">
                                                        Version: {goal?.prompt_version}
                                                      </span> */}
                            </div>
                          </TableCell>
                          {/* <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600 capitalize">{getReviewBadge(reviewLabel) || ""}
                              </span>
                            </div>
                          </TableCell> */}
                          <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600">{goal?.supervisorName}</span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col text-wrap w-52 font-medium text-gray-600">
                              {goal?.supervisorComment ? (
                                <TooltipProvider>
                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <span
                                        className="truncate cursor-help max-w-xs text-ellipsis overflow-hidden"
                                        onMouseEnter={(e) => e.stopPropagation()}
                                      >
                                        {goal.supervisorComment}
                                      </span>
                                    </TooltipTrigger>
                                    <TooltipContent
                                      side="top"
                                      className="bg-black text-white p-3 rounded-md text-sm max-w-sm max-h-60 overflow-y-auto whitespace-pre-line shadow-lg border border-gray-300"
                                    >
                                      {goal.supervisorComment}
                                    </TooltipContent>
                                  </Tooltip>
                                </TooltipProvider>
                              ) : <div className=''>-</div>}
                            </div>
                          </TableCell>
                          {/* <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600">{goal?.checkInTime || ""}</span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600">{goal?.checkOutTime || ""}</span>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col">
                              <span className="font-medium text-gray-600">{goal?.hours || ""}</span>
                            </div>
                          </TableCell> */}
                        </TableRow>
                      )
                    })}
                  </TableBody>



                </Table>

              </div>
              <div>
                {totalPages > 1 && (
                  <div className="px-6 py-4 border-t bg-gray-50">
                    <div className="flex justify-between items-center">

                      <PaginationCustom
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        onItemsPerPageChange={(newItemsPerPage) => {
                          onPageChange(1);
                        }}
                      />
                    </div>
                  </div>



                )}
              </div>
            </CardContent>
          </Card>
        </div>
        <Dialog open={updateKT} onOpenChange={() => setUpdateKT(false)}>
          <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
            <DialogHeader className='gap-y-5'>
              <DialogTitle>Update KanTime</DialogTitle>
              <DialogDescription>
                Are you sure you want to Update KanTime status for the selected charts?
              </DialogDescription>
            </DialogHeader>
            <DialogFooter>
              <Button variant="outline" onClick={() => setUpdateKT(false)}>
                Close
              </Button>
              <Button variant="approve" onClick={handleUpdateKantTime}>
                Update
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </Layout>
  )

}